import React, { useEffect, useState, useContext } from "react";
import { ECLLoader } from "../../../index";
import { ToastContext } from "../../../../utilities/contexts";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import "./ECLStopLight.css";

//ECLStopLight
//DATA:
//    -value: Takes a zero to display false, else true
//Draw Data:
//    -label: labels the stoplight
//    -size: provides the proportions of the stoplight as an array  (i.e. [1,1])
//    -upright: provides the orientation of the stoplight.

export default function ECLStopLight(props) {
   const stoplightId = useSelectorId();
   const [value, setValue] = useState(null);
   const [drawData, setDrawData] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
   const addToast = useContext(ToastContext);

   useEffect(() => {
      props
         .loader()
         .then((res) => {
            setValue(res.value);
            setDrawData(res.drawData);
            setLoading(false);
         })
         .catch((error) => {
            console.error(error);
            setError("Visualization request failed");
            addToast("Visualization request failed", "error");
         });
   }, [props.loader]);

   if (loading || error) {
      return <ECLLoader message={error} />;
   }

   // each tile size is 100 px
   const tileWidth = drawData.size[0] * 100;
   const tileHeight = drawData.size[1] * 100;
   let sizer;
   //Get the maximum size of the long end of the stop light
   if (drawData.upright) {
      sizer = tileHeight < tileWidth * 2 ? tileHeight : tileWidth * 2;
   } else {
      sizer = tileWidth < tileHeight * 2 ? tileWidth : tileHeight * 2;
   }
   sizer = sizer - 30; //Subtract 20px to account for tile label, and an additional 10px for padding

   return (
      <div className="stoplight-content">
         <label htmlFor={"stoplight" + stoplightId} className="tile-label">
            {drawData.label}
         </label>
         <div
            id={"stoplight" + stoplightId}
            className="stoplight-container"
            style={
               drawData.upright
                  ? { width: sizer / 2 + "px", height: sizer + "px" }
                  : { width: sizer + "px", height: sizer / 2 + "px" }
            }
         >
            <div
               className={
                  drawData.upright
                     ? "stop-light vertical"
                     : "stop-light horizontal"
               }
            >
               <div className={value ? "circle" : "circle red-circle"}></div>
               <div className={value ? "circle green-circle" : "circle"}></div>
            </div>
         </div>
      </div>
   );
}
